module.exports = __webpack_public_path__ + "img/wv.dc9e4539.gif";